import { BasicUserInfo } from "../../accounts/models/UserRolesInfo";
import { RecordInfo } from "../../common/models/RecordInfo";
import { PhoneModel } from "../../home/models/ContactInfo";
import { KeyValue } from "../../home/models/OtherTypes";
import { IPageFilterModel } from "../../home/models/PageTypes";
import { OrderRequestType } from "../../orders/models/OrderModel";
import { AddressInfo } from "./AddressModel";

export enum CustomerType {
    all = 0,
    retail = 1,
    wholesale = 2,
}

export enum CustomerFilterType {
    all = 0,
    openSaleOnly = 1,
    invoiceAvailable = 2,
    employeeOnly = 3,
    userOnly = 4,
    wholesaleOnly = 5,
}

export enum CustomerLevel {
    none = 0,
    regular = 1,
    invited = 2,
    trusted = 3,
    oneTime = 4,
}

export interface CustomerFilterModel extends IPageFilterModel {
    filterType: CustomerFilterType;
    level: CustomerLevel;
    grade: number;
}

export interface ShortCustomerModel {
    id: number;
    deleted: boolean;
    active: boolean;
    userId: string;
    displayName: string;
    countryCode: string;
    phoneNo: string;
    email: string;
    isEmployee: boolean;
    isUser: boolean;
    isOpenSales: boolean;
    invoiceAvailable: boolean;

    orderTotal: number;
    invoiceTotal: number;
    paymentTotal: number;

    type: CustomerType;
    level: CustomerLevel;
    grade: number;
    start: Date;
    saleDate?: Date;
    pictureId?: number;
    phones?: string;
    tokenCount: number;
    lastConnectedDate?: Date;
    totalPoint: number;

    filePath?: string;
    fileName?: string;

    orderDetails: KeyValue<OrderRequestType, number>[];
    orderRequestDate: Date;

    balance: number;
    imageUrl: string;
}

export interface CustomerModel {
    id: number;
    displayName: string;
    type: CustomerType;
    level: CustomerLevel;
    grade: number;
    start: Date;
    imageUrl?: string;
    email?: string;
    phone?: PhoneModel;
    address?: AddressInfo;
    orderTotal: number;
    invoiceTotal: number;
    paymentTotal: number;
    balance: number;
    user?: BasicUserInfo;
    tokenCount: number;
    lastConnectedDays: number;
    recordInfo: RecordInfo;
}